var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-column" }, [
    _c(
      "div",
      { staticClass: "scroll flex-1" },
      [
        _c("LoadingMini", { ref: "loading" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "messages",
            staticStyle: { "margin-top": "0", position: "static" },
          },
          [
            !!_vm.backendErrorMessages.length
              ? _c("div", { staticClass: "message error show" }, [
                  _c("i", {
                    staticClass: "fa fa-times",
                    on: {
                      click: function ($event) {
                        return _vm.removeErrorsMessages()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-exclamation-circle indicator",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "message-inner" },
                    _vm._l(_vm.backendErrorMessages, function (message) {
                      return _c("div", {
                        domProps: { textContent: _vm._s(message) },
                      })
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          { staticClass: "form", staticStyle: { overflow: "visible" } },
          [
            _c(
              "FormWrapper",
              [
                _c(
                  "FormControl",
                  [
                    _c("FormLabel", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("device.registrations.licence_number")
                          ) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("FormInput", {
                      staticClass: "text-mono",
                      attrs: {
                        value: _vm.formatLicenceId(_vm.datiId),
                        disabled: "",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormControl",
                  [
                    _c("FormLabel", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("device.registrations.phonenumber")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("FormInputPhone", {
                      attrs: {
                        name: "phoneNumber",
                        isInvalid:
                          _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid,
                      },
                      on: {
                        input: _vm.onPhoneInput,
                        blur: function () {
                          return (this$1.phoneNumberShowError = true)
                        },
                      },
                      model: {
                        value: _vm.phoneNumber,
                        callback: function ($$v) {
                          _vm.phoneNumber = $$v
                        },
                        expression: "phoneNumber",
                      },
                    }),
                    _vm._v(" "),
                    _vm.phoneNumberShowError && _vm.phoneNumberIsInvalid
                      ? _c("FormError", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.errors.invalidPhoneFormat"
                                )
                              ) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormControl",
                  [
                    _c("FormLabel", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("device.registrations.datiName")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("FormInput", {
                      attrs: {
                        name: "datiName",
                        isInvalid: _vm.datiNameIsInvalid,
                      },
                      on: { input: _vm.onDatiNameInput },
                      model: {
                        value: _vm.datiName,
                        callback: function ($$v) {
                          _vm.datiName = $$v
                        },
                        expression: "datiName",
                      },
                    }),
                    _vm._v(" "),
                    _vm.datiNameIsInvalid
                      ? _c("FormError", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.errors.label_needed"
                                )
                              ) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormControl",
                  [
                    _c("FormLabel", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("device.registrations.profile")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "FormSelect",
                      {
                        attrs: { isInvalid: _vm.datiProfileIsInvalid },
                        on: { input: _vm.onProfilInput },
                        model: {
                          value: _vm.datiProfile,
                          callback: function ($$v) {
                            _vm.datiProfile = $$v
                          },
                          expression: "datiProfile",
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(
                            "-- " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.profileSelectPlaceholder"
                                )
                              ) +
                              " --"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.props.profiles, function (profile) {
                          return _c(
                            "option",
                            {
                              key: profile.id,
                              domProps: { value: profile.profileId },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(profile.meta.name) +
                                  "\n                            " +
                                  _vm._s(profile.meta.default ? "★" : null) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.datiProfileIsInvalid
                      ? _c("FormError", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "device.registrations.errors.profile_needed"
                                )
                              ) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormControl",
                  [
                    _c("FormLabel", { attrs: { isOptional: "" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("device.groupSelect")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "FormSelect",
                      {
                        model: {
                          value: _vm.datiGroup,
                          callback: function ($$v) {
                            _vm.datiGroup = $$v
                          },
                          expression: "datiGroup",
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            staticClass: "text-muted",
                            domProps: { value: null },
                          },
                          [
                            _vm._v(
                              "-- " + _vm._s(_vm.$t("device.noGroup")) + " --"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.props.groups, function (group) {
                          return _c(
                            "option",
                            { key: group.id, domProps: { value: group.id } },
                            [_vm._v(_vm._s(group.name))]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasAnalytic
                  ? _c(
                      "FormControl",
                      [
                        _c("FormLabel", { attrs: { isOptional: "" } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("device.registrations.analyticCode")
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("FormInput", {
                          attrs: { maxlength: "30" },
                          model: {
                            value: _vm.analyticCode,
                            callback: function ($$v) {
                              _vm.analyticCode = $$v
                            },
                            expression: "analyticCode",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex tw-p-5" },
      [
        _c(
          "Btn",
          {
            staticClass: "ml-auto",
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.cancel($event)
              },
            },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("global.cancel")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "Btn",
          {
            staticClass: "primary ml-2",
            attrs: {
              disabled:
                _vm.phoneNumberIsInvalid ||
                _vm.datiNameIsInvalid ||
                _vm.datiProfileIsInvalid,
            },
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.validForm($event)
              },
            },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }